import { Component } from 'react';
import { connect } from 'react-redux';
import styles from './IndexDocumentActions.scss';
import {
    resetIndexDocument,
    restoreLastSavedDocument,
    ascertainDocument,
} from 'indexDocuments/actions';
import {
    calculateSaveButtonDisableState,
    calculateRestoreButtonVisibility,
    calculateSavingFlag,
    calculateFileAndSendButtonVisibility,
} from 'indexDocuments/selectors';

class IndexDocumentActions extends Component {
    render() {
        const {
            binder,
            saving,
            restoreVisible,
            saveDisabled,
            saveDisabledMessage,
            ascertainDocument,
            restoreLastSavedDocument,
            resetIndexDocument,
            fileAndSendVisible,
            indexingType,
            isConversionSuccessful,
        } = this.props;
        const shouldRedirectToSDFAUponSuccessfulSave = true;
        const shouldDisplayInitialIndexingButtons = indexingType === 'initialIndex';
        const shouldDisplayFileAndSend = fileAndSendVisible && shouldDisplayInitialIndexingButtons && isConversionSuccessful;
        const fileButtonTitleInitialState = shouldDisplayInitialIndexingButtons ? 'File Document' : 'Save';
        const fileButtonTitle = saving ? 'Saving' : fileButtonTitleInitialState;
        const restoreButton = restoreVisible ? (
            <button
                type="button"
                disabled={saving}
                className={styles.resetButton}
                onClick={e => restoreLastSavedDocument()}
                data-cy="IndexDocumentActionsBtn">
                Restore
            </button>
        ) : null;

        return (
            <div className={styles.buttonSet} data-cy="IndexDocumentActions">
                <button
                    disabled={saving}
                    className={styles.resetFields}
                    onClick={e => resetIndexDocument()}
                    data-cy="IndexDocumentActions-reset">
                    Reset Fields
                </button>
                <button
                    type="button"
                    className={styles.fileOnly}
                    disabled={saveDisabled}
                    onClick={e => ascertainDocument(binder.id, !shouldRedirectToSDFAUponSuccessfulSave)}
                    title={saveDisabledMessage}
                    data-cy="IndexDocumentActions-title">
                    {fileButtonTitle}
                </button>
                { shouldDisplayFileAndSend &&
                    <button
                        type="button"
                        className={styles.fileAndSend}
                        disabled={saveDisabled}
                        onClick={e => ascertainDocument(binder.id, shouldRedirectToSDFAUponSuccessfulSave)}
                        title={saveDisabledMessage}
                        data-cy="IndexDocumentActions-ascertai">
                        File and Send Document
                    </button>
                }
                {restoreButton}
            </div>
        );
    }
}

export default connect(state => {
    const { disabled, message } = calculateSaveButtonDisableState(state);
    const restoreVisible = calculateRestoreButtonVisibility(state);
    const saving = calculateSavingFlag(state);
    const fileAndSendVisible = calculateFileAndSendButtonVisibility(state);
    return {
        saveDisabled: disabled,
        saveDisabledMessage: message,
        restoreVisible,
        saving,
        fileAndSendVisible,
    };
}, {
    resetIndexDocument,
    restoreLastSavedDocument,
    ascertainDocument,
})(IndexDocumentActions);
